<div class="skeleton-container">
  <!-- Left Panel Skeleton -->
  <div class="skeleton-panel left">
    <div class="skeleton-box title"></div>
    <div class="skeleton-box line"></div>
    <div class="skeleton-box line short"></div>

    <div class="skeleton-box section"></div>
    <div class="skeleton-box line"></div>
    <div class="skeleton-box line"></div>
    <div class="skeleton-box line"></div>
  </div>

  <!-- Right Panel Skeleton -->
  <div class="skeleton-panel right">
    <div class="skeleton-box title"></div>
    <div class="skeleton-box line"></div>
    <div class="skeleton-box line"></div>
    <div class="skeleton-box line"></div>

    <div class="skeleton-box section"></div>
    <div class="skeleton-box line"></div>
    <div class="skeleton-box line short"></div>
  </div>
</div>
